import { getFormatDate } from '../../../../utils/Common';

/**
 * Formatea el nombre completo del cliente para display
 * @param {object} client - Objeto del cliente
 * @returns {string} Nombre completo formateado
 */
export const formatClientDisplayName = (client) => {
  if (!client) return 'N/A';
  const nombre = client?.Nombre || '';
  const apellidos = client?.Apellidos || '';
  return [nombre, apellidos].filter(Boolean).join(' ') || 'N/A';
};

/**
 * Formatea el subtítulo del cliente con información relevante
 * @param {object} client - Objeto del cliente
 * @returns {string} Subtítulo formateado
 */
export const formatClientSubtitle = (client) => {
  if (!client) return 'N/A';
  const code = formatClientCode(client);
  const username = client?.Usuario || '';
  return `ID: ${code}${username ? ` | Usuario: ${username}` : ''}`;
};

/**
 * Formatea el código del cliente
 * @param {object} client - Objeto del cliente
 * @returns {string} Código formateado
 */
export const formatClientCode = (client) => {
  if (!client) return 'N/A';
  const prefix = client?.IdTipoCliente === 1 ? 'B' : '';
  return `${prefix}${client?.IdCliente || ''}`;
};

/**
 * Formatea el nombre completo con ID para el header
 * @param {object} client - Objeto del cliente
 * @returns {string} Nombre completo con ID
 */
export const formatClientNameWithId = (client) => {
  if (!client) return 'N/A';
  const nombre = client?.Nombre || '';
  const apellidos = client?.Apellidos || '';
  const prefix = client?.IdTipoCliente === 1 ? 'B' : '';
  const idCliente = client?.IdCliente || '';
  const fullName = [nombre, apellidos].filter(Boolean).join(' ');
  return `${fullName} (${prefix}${idCliente})`.trim() || 'N/A';
};

